import { render } from "./RevenueBreakdown.vue?vue&type=template&id=6cf9f30e&scoped=true"
import script from "./RevenueBreakdown.vue?vue&type=script&lang=js"
export * from "./RevenueBreakdown.vue?vue&type=script&lang=js"

import "./RevenueBreakdown.vue?vue&type=style&index=0&id=6cf9f30e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf9f30e"]])

export default __exports__